import axios from 'axios';
import getExportUrl from './exportUrl';

import { configureHttpHeaders, onSuccess, onError } from './apiHelpers';

const EXPORT_API = getExportUrl();

export function exportCaseSearchQueueData(data) {
  const url = `api/v1/export/casesearch`;
  configureHttpHeaders(axios);
  return post(`${EXPORT_API}${url}`, data);
}

export function exportUnmatchedQueue(data) {
  const url = `api/v1/export/unmatched/transaction`;
  configureHttpHeaders(axios);
  return post(`${EXPORT_API}${url}`, data);
}
export function exportActiveStageQueue(data) {
  const url = `api/v1/export/activate/stage`;
  configureHttpHeaders(axios);
  return post(`${EXPORT_API}${url}`, data);
}
export function exportDataSearchQueue(data, type) {
  const url = `api/v1/export/datasearch/${type}`;
  configureHttpHeaders(axios);
  return post(`${EXPORT_API}${url}`, data);
}
export function exportMerchantQueueData(data) {
  const url = `api/v1/export/unmatched/merchants`;
  configureHttpHeaders(axios);
  return post(`${EXPORT_API}${url}`, data);
}
export function exportAmexQueueData(data) {
  const url = `api/v1/export/amex`;
  configureHttpHeaders(axios);
  return post(`${EXPORT_API}${url}`, data);
}
export function exportWexQueueData(data) {
  const url = `api/v1/export/wex`;
  configureHttpHeaders(axios);
  return post(`${EXPORT_API}${url}`, data);
}
export function exportImageQueueData(data) {
  const url = `api/v1/export/imagedata`;
  configureHttpHeaders(axios);
  return post(`${EXPORT_API}${url}`, data);
}
export function exportQuickSearchQueueData(data) {
  const url = `api/v1/export/quicksearch`;
  configureHttpHeaders(axios);
  return post(`${EXPORT_API}${url}`, data);
}
export function exportUserQueueData(data, customQueueId, searchType) {
  let url = `api/v1/export/investigator/default/queue/data`;
  if (customQueueId && searchType) {
    url = url + `?customQueueId=${customQueueId}&searchType=${searchType}`;
  } else if (customQueueId) {
    url = url + `?customQueueId=${customQueueId}`;
  } else if (searchType) {
    url = url + `?searchType=${searchType}`;
  }
  configureHttpHeaders(axios);
  return post(`${EXPORT_API}${url}`, data);
}

export function exportRelatedCasesData(data) {
  const url = `api/v1/export/relatedcases`;
  configureHttpHeaders(axios);
  return post(`${EXPORT_API}${url}`, data);
}

function post(postUrl, postData) {
  return axios({
    method: 'post',
    url: postUrl,
    data: postData,
  })
    .then(onSuccess)
    .catch(onError);
}

export default {
  exportAmexQueueData,
  exportImageQueueData,
  exportQuickSearchQueueData,
  exportMerchantQueueData,
  exportDataSearchQueue,
  exportUnmatchedQueue,
  exportActiveStageQueue,
  exportCaseSearchQueueData,
  exportUserQueueData,
  exportRelatedCasesData,
};
